module.exports = __webpack_public_path__ + "img/facebook-white.d1524800.svg";